<template>
    <div :class="b()">

        <div v-if="this.hasRequests === false" class="col-sm-12 no-favorites noitem-message">
            <div class="noitem-message"><p>Нет ни одной заявки</p></div>
        </div>

        <div v-else v-for="request in this.requestsData">
            <request-items-component :from="from" :request="request" ></request-items-component>
        </div>

    </div>
</template>

<script>
    import RequestService from '../services/RequestService';
    import BuyingService from "../services/BuyingService";
    import RequestItemsComponent from "./RequestItemsComponent";

    const COMPONENT_NAME = 'request-component';

    export default {
        name: COMPONENT_NAME,
        components: {RequestItemsComponent},
        props: {
            requests: Object,
            from: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                requestsData: {},
                hasRequests: true,
                selected: [],
            }
        },
        mounted() {
            this.checkRequests();
        },
        methods: {
            async checkRequests() {
                if (this.requests.length === 0) {
                    this.hasRequests = false;
                } else {
                    this.requestsData = this.requests;
                }
            },
            async getRequests() {
                let response = await BuyingService.getRequests();
                if (response.success) {
                    this.requestsData = response.requests.requests;
                }
            },
        }
    }
</script>

<style>

</style>